<template>
  <Popup :alt="true" v-model="errorMessage.show">
    <div class="thanks">
      <div class="thanks__title thanks__title_err active" v-html="errorMessage.title">
      </div>
      <div class="pfpopup__text" v-html="errorMessage.text"></div>
      <Btn class="thanks__btn thanks__btn_err" v-if="errorMessage.btnText" @click.stop.prevent="$store.commit('hideErrorMessage')">{{ errorMessage.btnText }}</Btn>
    </div>
  </Popup>
</template>

<script>
import { mapState } from 'vuex';
import Popup from './Popup.vue';
import Btn from './ui/Btn.vue';
export default {
  components: { Popup, Btn },
  computed: {
    ...mapState(['errorMessage']), //id === ordernumber
  },
}
</script>

<style lang="sass">
.thanks__title.thanks__title_err
  padding-top: 16px
.thanks .thanks__btn.thanks__btn_err
  margin-bottom: 32px
</style>